// removed by extract-text-webpack-plugin
module.exports = {"block":"BrandElementCard_block_yAePJ","content":"BrandElementCard_content_1O3oW","image":"BrandElementCard_image_1Azux"};